// общие модули страницы v2: аналитика, UTM, cookie, форма Ядра, переключатель языка
import '../components/form'
import '../components/policy'
import '../components/amplitude'
import '../saveUTMtoCookies'

// переключатель языка: открывается по клику, закрывается по клику снаружи и Esc, работает с клавиатуры
const initLang = () => {
  const dd = document.querySelector('.lang-dd')
  if (!dd || dd.dataset.ready) return
  dd.dataset.ready = '1'
  const btn = dd.querySelector('.lang-btn')
  const menu = dd.querySelector('.lang-menu')
  const items = [].slice.call(menu.querySelectorAll('.lang-it'))
  const isOpen = () => btn.getAttribute('aria-expanded') === 'true'
  const open = (focus) => {
    menu.hidden = false
    btn.setAttribute('aria-expanded', 'true')
    if (focus) (items.filter(i => !i.classList.contains('on'))[0] || items[0]).focus()
  }
  const close = (focus) => {
    if (!isOpen()) return
    menu.hidden = true
    btn.setAttribute('aria-expanded', 'false')
    if (focus) btn.focus()
  }
  btn.addEventListener('click', () => (isOpen() ? close() : open(false)))
  btn.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(true) }
  })
  menu.addEventListener('keydown', (e) => {
    const k = items.indexOf(document.activeElement)
    if (e.key === 'ArrowDown') { e.preventDefault(); items[(k + 1) % items.length].focus() }
    if (e.key === 'ArrowUp') { e.preventDefault(); items[(k - 1 + items.length) % items.length].focus() }
    if (e.key === 'Tab') close(false)
  })
  // текущий язык: просто закрыть меню
  items.forEach((it) => {
    if (it.classList.contains('on')) it.addEventListener('click', (e) => { e.preventDefault(); close(true) })
  })
  document.addEventListener('click', (e) => { if (!dd.contains(e.target)) close(false) })
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(dd.contains(document.activeElement)) })
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initLang)
else initLang()
